import React, { useState } from "react";
import { useHistory } from 'react-router-dom';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const history = useHistory();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="relative px-4 sm:px-6 md:px-8 lg:px-[110px] py-6 md:py-8">
      <div className="flex items-center justify-between">
        {/* Logo */}
        <a href="/entrance" className="w-[100px] h-[30px] sm:w-[120px] sm:h-[36px] md:w-[131px] md:h-[39px] flex-shrink-0">
          <img
            src="/assets/landing-2025/magikk-logo.svg"
            alt="Magikk Logo"
            className="w-full h-full object-contain"
          />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-[24px] xl:gap-[32px] text-[#002342]">
          <a 
          href="#solucoes"
          className="font-medium text-[14px] xl:text-[16px] flex items-center gap-[6px] hover:text-[#85C4FF] transition-colors">
            Soluções
          </a>
          <a href="#quem-somos" className="font-medium text-[14px] xl:text-[16px] hover:text-[#85C4FF] transition-colors">Quem Somos</a>
          <a 
          onClick={() => window.open('https://apps.apple.com/br/app/magikk-goods-and-good-deeds/id1502548875')}
           className="font-medium text-[14px] xl:text-[16px] hover:text-[#85C4FF] transition-colors cursor-pointer">App</a>
          <a 
          onClick={() => history.push('/company-form-2025')}
           className="font-medium text-[14px] xl:text-[16px] hover:text-[#85C4FF] transition-colors cursor-pointer">Fale com a gente</a>
        </nav>

        {/* Desktop Header Actions */}
        <div className="hidden md:flex items-center gap-[20px] lg:gap-[36px]">
          <a onClick={() => history.push('/login')} className="text-[#85C4FF] font-semibold text-[14px] lg:text-[16px] hover:text-[#002342] transition-colors cursor-pointer">
            Entrar
          </a>
          <button 
          onClick={() => history.push('/register')}
          className="bg-[#002342] text-white px-[12px] lg:px-[16px] py-[10px] lg:py-[14px] rounded-[20px] font-semibold text-[14px] lg:text-[16px] hover:bg-[#85C4FF] transition-colors whitespace-nowrap cursor-pointer">
            Cadastre-se
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 text-[#002342] hover:text-[#85C4FF] transition-colors"
          onClick={toggleMobileMenu}
          aria-label="Menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" className="stroke-current" fill="none">
            {isMobileMenuOpen ? (
              <path d="M18 6L6 18M6 6l12 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            ) : (
              <path d="M3 12h18M3 6h18M3 18h18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100 z-50">
          <nav className="flex flex-col px-4 py-6 space-y-4">
            <a href="#solucoes" className="font-medium text-[16px] flex items-center justify-between text-[#002342] hover:text-[#85C4FF] transition-colors py-2">
              Soluções
            </a>
            <a href="#quem-somos" className="font-medium text-[16px] text-[#002342] hover:text-[#85C4FF] transition-colors py-2">Quem Somos</a>
            <a 
            onClick={() => window.open('https://apps.apple.com/br/app/magikk-goods-and-good-deeds/id1502548875')}
            className="font-medium text-[16px] text-[#002342] hover:text-[#85C4FF] transition-colors py-2">App</a>
            <a
            onClick={() => history.push('/company-form-2025')}
             className="font-medium text-[16px] text-[#002342] hover:text-[#85C4FF] transition-colors py-2">Fale com a gente</a>

            {/* Mobile Actions */}
            <div className="flex flex-col space-y-3 pt-4 border-t border-gray-100">
              <a
              onClick={() => history.push('/login')}
              className="text-[#85C4FF] font-semibold text-[16px] hover:text-[#002342] transition-colors text-center py-2">
                Entrar
              </a>
              <button 
              onClick={() => history.push('/register')}
              className="bg-[#002342] text-white px-[16px] py-[14px] rounded-[20px] font-semibold text-[16px] hover:bg-[#85C4FF] transition-colors w-full">
                Cadastre-se
              </button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
